(function () {
  'use strict';

  function priceElement(button) {
    var card = button.closest('.js-product-card');
    return (card || document).querySelector(button.dataset.whatsappPriceSelector);
  }

  function updateEnquiry(button) {
    var price = priceElement(button);
    if (!price) return; // Keep the Liquid-generated price for sold-out cards.
    var priceCopy = price.cloneNode(true);
    priceCopy.querySelectorAll('.visually-hidden, s, .product-card__regular-price').forEach(function (label) {
      label.remove();
    });
    var currentPrice = priceCopy.querySelector('.money') || priceCopy;
    var displayedPrice = currentPrice.textContent.trim().replace(/\s+/g, ' ');
    if (!displayedPrice) return;
    var message = "Hi Wristime, I'm interested in " + button.dataset.productTitle +
      " listed at " + displayedPrice + ". Could I check if it's still available?\n\n" +
      button.dataset.productUrl;
    button.href = 'https://wa.me/6588896885?text=' + encodeURIComponent(message);
  }

  document.querySelectorAll('[data-whatsapp-enquiry]').forEach(function (button) {
    updateEnquiry(button);
    var price = priceElement(button);
    if (price) {
      new MutationObserver(function () { updateEnquiry(button); })
        .observe(price, { childList: true, subtree: true, characterData: true });
    }
  });

  // Delegation also covers cards inserted by collection filtering/pagination.
  function updateClickedEnquiry(event) {
    var button = event.target.closest('[data-whatsapp-enquiry]');
    if (button) updateEnquiry(button);
  }
  document.addEventListener('click', updateClickedEnquiry, true);
  document.addEventListener('auxclick', updateClickedEnquiry, true);
})();
